export const createReduxAction = type => data => dispatch =>
  dispatch({
    type,
    data,
  });



// WEBPACK FOOTER //
// ./src/store/modules/utils/reduxHelpers.js